import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { PLATFORM_DISPLAY_SHORT_NAME, PLATFORM_URL } from '../../constants/platform';
const RoutableHead = ({ children, description, image = `${process.env.REACT_APP_STATIC_BASE_PATH}/images/sem/sem-generic.png`, noIndex = false, subtitle, themeColor, title = 'Routable', twitterImage = `${process.env.REACT_APP_STATIC_BASE_PATH}/images/sem/sem-home-twitter.png`, }) => {
    const siteTitle = useMemo(() => {
        const initialTitle = subtitle ? `${title} - ${subtitle}` : title;
        return initialTitle.endsWith(PLATFORM_DISPLAY_SHORT_NAME)
            ? initialTitle
            : `${initialTitle} | ${PLATFORM_DISPLAY_SHORT_NAME}`;
    }, [title, subtitle]);
    return (React.createElement(Helmet, null,
        React.createElement("title", null, siteTitle),
        noIndex && React.createElement("meta", { content: "noindex", name: "robots" }),
        description && React.createElement("meta", { content: description, name: "description" }),
        React.createElement("meta", { content: image, name: "image" }),
        description && React.createElement("meta", { content: description, itemProp: "description" }),
        React.createElement("meta", { content: "Routable", itemProp: "name" }),
        React.createElement("meta", { content: image, itemProp: "image" }),
        React.createElement("meta", { content: "summary", name: "twitter:card" }),
        description && React.createElement("meta", { content: description, name: "twitter:description" }),
        React.createElement("meta", { content: siteTitle, name: "twitter:title" }),
        React.createElement("meta", { content: "@RoutableHQ", name: "twitter:site" }),
        React.createElement("meta", { content: twitterImage, name: "twitter:image:src" }),
        description && React.createElement("meta", { content: description, property: "og:description" }),
        React.createElement("meta", { content: image, property: "og:image" }),
        React.createElement("meta", { content: "en_US", property: "og:locale" }),
        React.createElement("meta", { content: "Routable", property: "og:site_name" }),
        React.createElement("meta", { content: siteTitle, property: "og:title" }),
        React.createElement("meta", { content: "website", property: "og:type" }),
        React.createElement("meta", { content: PLATFORM_URL, property: "og:url" }),
        React.createElement("meta", { content: "RoutableHQ", property: "fb:admins" }),
        themeColor && React.createElement("meta", { content: themeColor, media: "(prefers-color-scheme: light)", name: "theme-color" }),
        themeColor && React.createElement("meta", { content: themeColor, media: "(prefers-color-scheme: dark)", name: "theme-color" }),
        children));
};
export default RoutableHead;
